/* Content section V6 aka Image strip */

import { useRef } from 'react';
import { reactMount } from '@/lib/reactMount';
import {
  getPricingRegionByCountryIso,
  PricingRegion,
} from '../../lib/pricingMatrix/PricingRegion';

const ContentSectionV6 = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco));
  umbraco ||= umbracoRef.current;

  const theme = umbraco?.Theme || 'charcoal-light';

  const pricingRegion = getPricingRegionByCountryIso(
    window.localStorage.getItem('countryIso') ||
      window.localStorage.getItem('regionIso'),
  );
  const isGB = pricingRegion === PricingRegion.GBR;

  let logosTheme = 'light';
  if (theme?.includes('light')) logosTheme = 'dark';

  return (
    <div
      id={umbraco?.AnchorTarget || null}
      data-theme={theme}
      className="bg-[--theme-bg] py-8 lg:py-16"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-base font-medium text-[--theme-text]">
          Timely. Trusted by salons worldwide.
        </h2>

        {!!isGB && logosTheme === 'dark' && (
          <div className="mx-auto mt-3 grid max-w-lg grid-cols-3 place-items-center gap-x-3 gap-y-5 sm:max-w-xl lg:mx-0 lg:flex lg:max-w-none lg:flex-nowrap lg:items-center lg:justify-between lg:gap-x-6 lg:gap-y-0">
            <img
              alt="RIO"
              src="/static/image/partner-logos/uk/rio-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Blanc Studios"
              src="/static/image/partner-logos/uk/blanc_studios-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Josh Wood Colour"
              src="/static/image/partner-logos/uk/josh_wood_colour-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Hair & Beauty Charity"
              src="/static/image/partner-logos/uk/hair_and_beauty_charity-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Jack Andrews"
              src="/static/image/partner-logos/uk/jack_andrews-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Liane Godfrey"
              src="/static/image/partner-logos/uk/liane_godfrey-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
          </div>
        )}

        {!!isGB && logosTheme === 'light' && (
          <div className="mx-auto mt-3 grid max-w-lg grid-cols-3 place-items-center gap-x-3 gap-y-5 sm:max-w-xl lg:mx-0 lg:flex lg:max-w-none lg:flex-nowrap lg:items-center lg:justify-between lg:gap-x-6 lg:gap-y-0">
            <img
              alt="RIO"
              src="/static/image/partner-logos/uk/rio-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Blanc Studios"
              src="/static/image/partner-logos/uk/blanc_studios-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Josh Wood Colour"
              src="/static/image/partner-logos/uk/josh_wood_colour-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Hair & Beauty Charity"
              src="/static/image/partner-logos/uk/hair_and_beauty_charity-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Jack Andrews"
              src="/static/image/partner-logos/uk/jack_andrews-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Liane Godfrey"
              src="/static/image/partner-logos/uk/liane_godfrey-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
          </div>
        )}

        {!isGB && logosTheme === 'dark' && (
          <div className="mx-auto mt-3 grid max-w-lg grid-cols-3 place-items-center gap-x-3 gap-y-5 sm:max-w-xl lg:mx-0 lg:flex lg:max-w-none lg:flex-nowrap lg:items-center lg:justify-between lg:gap-x-6 lg:gap-y-0">
            <img
              alt="SSkin"
              src="/static/image/partner-logos/other/sskin-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="AHC"
              src="/static/image/partner-logos/other/ahc-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Mamawest"
              src="/static/image/partner-logos/other/mamawest-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="ABIC"
              src="/static/image/partner-logos/other/abic-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Haus of Vakai"
              src="/static/image/partner-logos/other/haus_of_vakai-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Jin Soon"
              src="/static/image/partner-logos/other/jinsoon-charcoal.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
          </div>
        )}

        {!isGB && logosTheme === 'light' && (
          <div className="mx-auto mt-3 grid max-w-lg grid-cols-3 place-items-center gap-x-3 gap-y-5 sm:max-w-xl lg:mx-0 lg:flex lg:max-w-none lg:flex-nowrap lg:items-center lg:justify-between lg:gap-x-6 lg:gap-y-0">
            <img
              alt="SSkin"
              src="/static/image/partner-logos/other/sskin-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="AHC"
              src="/static/image/partner-logos/other/ahc-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Mamawest"
              src="/static/image/partner-logos/other/mamawest-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="ABIC"
              src="/static/image/partner-logos/other/abic-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Haus of Vakai"
              src="/static/image/partner-logos/other/haus_of_vakai-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
            <img
              alt="Jin Soon"
              src="/static/image/partner-logos/other/jinsoon-white.png"
              height={80}
              className="w-full min-w-0 object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};

reactMount('ContentSectionV6', ContentSectionV6);
